// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout_logo__H\\+rlx {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 70px;
}

.layout_footer__fg5v8 {
  height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/shared/layout/layout.module.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;AADF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.logo {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  height: 70px;\n}\n\n.footer {\n  height: 100px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `layout_logo__H+rlx`,
	"footer": `layout_footer__fg5v8`
};
export default ___CSS_LOADER_EXPORT___;
